module.exports = __webpack_public_path__ + "media/images/avatar/6-517acf0dd90ebc6d9193db3d4586a0ea.jpg";